import forOwn from "lodash/forOwn";
import get from "lodash/get";

export default class BaseMappingsModel {
    constructor(mappings, data) {
        this.mapData(data || {}, mappings);
    }

    mapData(data, mappings) {
        forOwn(mappings, (source, target) => {
            let filedDescr, sourceProp, sourceModel;

            if (source instanceof Array) {
                filedDescr = source[0];
                sourceProp = filedDescr.prop;
                sourceModel = filedDescr.model;

                if (get(data, sourceProp) instanceof Array) {
                    this[target] = get(data, sourceProp).map((item) => new sourceModel(item));
                } else {
                    this[target] = get(data, source);
                }
            } else if (source instanceof Object && get(data, source.prop)) {
                this[target] = new source.model(get(data, source.prop));
            } else {
                this[target] = get(data, source);
            }
        });
    }
}
